export default __webpack_public_path__ + "static/media/harvesters.46641efd.jpg";